import store from "@/store";
import { getFromLocalStorage } from "@/utils/localstorage";

export default async function notAuth({ next, to }) {
  store.commit("auth/clearErrors");
  const token = getFromLocalStorage("authtoken", null);

  if (token && to.query.returnURL) {
    return (window.location = to.query.returnURL);
  }

  if (token) {
    return next({ name: "Dashboard" });
  }

  return next();
}
